<template>
  <div>
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="12" md="11" sm="12">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          width="350"
          contain
        />
      </v-col>
    </v-toolbar>

    <!-- pricing section -->

    <div>
      <!-- CTA section -->
      <section class="call-to-action pricing-offer">
        <div class="container">
          <div class="offer-text text-center">
            <h3 class="cta-title">up to 33% off</h3>
          </div>
        </div>
      </section>
      <!-- CTA section -->

      <!-- Pricing-wrapper section -->
      <section class="pricing-wrapper">
        <div class="container">
          <div class="section-header">
            <br />
            <h2 class="sec-title">Pricing Plans</h2>
            <p>
              Clear & Simple Pricing - <strong> All Features Included!</strong>
            </p>
          </div>

          <div class="pricing-container">
            <div class="pricing-box text-center">
              <div class="save">
                <p>1 MONTH</p>
              </div>
              <div class="inner-box">
                <h5 class="old-price">
                  <span class="strikethrough">$49</span>
                </h5>
                <h3 class="price">$39.99 /mo</h3>
                <router-link
                  :to="{ name: 'ClickSignUpForm' }"
                  class="btn read-more-btn"
                  >join now</router-link
                >
                <p class="mt-3 text-muted">
                  <small>Cancel anytime</small>
                </p>
              </div>
            </div>

            <!-- <div class="pricing-box text-center">
              <div class="save">
                <p>3 MONTHS</p>
              </div>
              <div class="inner-box">
                <h5 class="old-price">
                  <span class="strikethrough">$147</span>
                </h5>
                <h4 class="price">$29.99/mo</h4>
                <div class="smallPrice"><h6>(billed as $89.97)</h6></div>
                <a
                  href="https://app.fantasylineups.com/sign-up"
                  class="btn read-more-btn"
                  >join now</a
                >
                <p class="mt-3 text-muted">
                  <small>Cancel anytime</small>
                </p>
              </div>
            </div> -->

            <!-- <div class="pricing-box text-center">
              <div class="save">
                <p>1 YEAR</p>
              </div>
              <div class="inner-box">
                <h5 class="old-price">
                  <span class="strikethrough">$499</span>
                </h5>
                <h5 class="price">$22.99/mo</h5>
                <div class="smallPrice"><h6>(billed as $275.88)</h6></div>
                <a
                  href="https://app.fantasylineups.com/sign-up"
                  class="btn read-more-btn"
                  >join now</a
                >
                <p class="mt-3 text-muted">
                  <small>Cancel anytime</small>
                </p>
              </div>
            </div> -->
          </div>
        </div>
      </section>
      <!-- Pricing-wrapper section -->

      <!-- Logo bar section -->
      <section class="logo-bar sec-padding-sm servicing">
        <div class="container">
          <div class="section-header">
            <h2 class="sec-title">Servicing</h2>
            <p>Start building better fantasy lineups on:</p>
          </div>

          <v-row justify="center">
            <!-- draftkings -->
            <v-col cols="6" md="3" sm="4" class="mt-3">
              <v-img
                src="/img/draftkings-logo.png"
                class="logo mx-auto mt-n10"
                height="100"
                width="250"
                contain
              />
            </v-col>
            <!-- fanduel -->
            <v-col cols="6" md="3" sm="4" class="mt-n10">
              <v-img
                src="/img/fanduel-logo.png"
                class="logo mx-auto mt-n10"
                height="250"
                width="250"
                contain
              />
            </v-col>
          </v-row>
        </div>
      </section>
      <!-- Logo bar section -->

      <!-- Features section -->
      <section class="dfs-guide sec-padding-lg features">
        <div class="container">
          <div class="section-header">
            <h2 class="sec-title">Features</h2>
            <p>
              The features were built to give you a serious DFS edge, while
              saving your hours each day - who has time for that!
            </p>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Player Projections</h4>
                <p>Live Up to the Minute Player Projections</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Fantasy Lineups DFS Optimizer</h4>
                <p>NBA, MLB, NHL, NFL</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Min/Max Exposure</h4>
                <p>Set Minimum & Maximum Player Exposure</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Team Stacks</h4>
                <p>Team Exposures in an Instant</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Expert "Top plays" filters</h4>
                <p>Premium Insights Giving you an Edge</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Mass Lineup Creation</h4>
                <p>Build Hundreds of Lineups in Seconds</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Deep Insights</h4>
                <p>Detailed Team & Player Insights</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Export Lineups</h4>
                <p>Export Lineups into Draftkings & Fanduel</p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <div class="fdo-card">
                <h4>Easy to use Interface</h4>
                <p>Modern, Simple, & Straight Forward</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Features section -->
    </div>
    <!-- pricing section -->

    <script
      type="application/javascript"
      defer
      src="//cbtb.clickbank.net/?vendor=dfslineups"
    ></script>
  </div>
</template>

<script>
export default {
  name: "clickPricingPage",
  title: "Fantasylinesups.com Membership Plans",

  methods: {
    backButton() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="css">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap");

/* * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  } */

/* :root {
    --primaryColor: #669900;
    --primaryLightColor: rgb(102, 153, 0, 0.05);
    --darkColor: #000000;
    --textColor: #444444;
    --whiteColor: #ffffff;
    --lightGrey: #f1f1f1;
    --danger: #ef4b4b;
  } */

body {
  width: 100%;
  height: 100%;
  scroll-behavior: smooth;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: bold;
  line-height: 120%;
}

a,
p,
span {
  line-height: 150%;
  color: #444444;
}

a {
  text-decoration: none;
}

/* /////////// Scrollbar //////////// */
/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #669900;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #444444;
}
/* /////////// Scrollbar //////////// */

.sec-padding-lg {
  padding: 100px 0;
}

.sec-padding-md {
  padding: 80px 0;
}

.sec-padding-sm {
  padding: 60px 0;
}

.btn {
  transition: all 0.3s ease-in-out 0s;
  outline: none;
}

.btn-outline {
  border-radius: 30px;
  color: #ffffff;
  border: 2px solid #ffffff;
  line-height: 56px;
  padding: 0 30px;
  text-transform: capitalize;
  font-weight: 600;
}

.btn-outline:hover {
  color: #669900;
  background: #ffffff;
}

.read-more-btn {
  border-radius: 30px;
  color: #669900;
  border: 2px solid #669900;
  line-height: 48px;
  padding: 0 30px;
  text-transform: capitalize;
  font-weight: 500;
  margin-top: 20px;
}

.read-more-btn:hover {
  color: #ffffff;
  background: #669900;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* //////////////////// End Global Setup ///////////////////// */

/* --------- Start Navbar Css ---------- */
.navbar {
  background-color: #000000;
  padding: 15px 0;
}

.navbar .nav-link {
  color: #ffffff;
}

.navbar .navbar-brand img {
  height: 80px;
}

.navbar .nav-link {
  line-height: 40px;
  padding: 0 15px !important;
}

.login-btn {
  border: 1px solid #ffffff;
  text-align: center;
  min-width: 100px;
  border-radius: 30px;
  margin: 0 12px;
}

.join-btn {
  color: #ffffff;
  background: #669900;
  text-align: center;
  min-width: 100px;
  border-radius: 30px;
}

.menu-icon {
  position: relative;
  width: 36px;
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
}

.menu-icon .line {
  width: 100%;
  height: 3px;
  background: #ffffff;
}

/* --------- End Navbar Css ---------- */

/* --------- Start Hero Banner Css ---------- */
.hero-banner {
  padding: 150px 0;
  /* background: url(images/Hero_Banner.png) no-repeat; */
  background-position: center;
  background-size: cover;
}

.hero-banner .hero-content h1 {
  font-size: 64px;
  color: #669900;
}

.label {
  text-transform: uppercase;
}

.hero-banner .hero-content p.description {
  width: 80%;
}

.hero-banner .hero-content .comming-soon {
  width: auto;
  color: #ffffff;
  background-color: #669900;
  padding: 12px 26px;
  float: left;
  font-size: 20px;
  font-weight: 500;
  text-transform: uppercase;
  border-radius: 30px;
  margin-top: 30px;
}

.hero-banner .hero-img-container {
  /* text-align: right; */
  height: 100%;
  display: flex;
  align-items: center;
}

.hero-banner .video-wrapper {
  width: 540px;
  height: 300px;
  position: relative;
  margin-left: 20px;
  z-index: 1;
}

.hero-banner .video-wrapper::after {
  content: "";
  position: absolute;
  top: 20px;
  left: -20px;
  width: 100%;
  height: 100%;
  background: rgba(102, 153, 0, 0.15);
  border-radius: 12px;
  z-index: -1;
}

.hero-banner .inner-content-video {
  width: 100%;
  height: 100%;
  background: #f1f1f1;
  overflow: hidden;
  border-radius: 12px;
}

.hero-banner .inner-content-video * {
  width: 100%;
  height: 100%;
}

.hero-banner .hero-img-container img {
  height: 340px;
  border-radius: 12px;
}

/* --------- End Hero Banner Css ---------- */

/* --------- Start Logo Bar Css ---------- */
.logo-bar {
  background: #669900;
}

.logo-bar .logobar-content h5 {
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 0;
  line-height: normal;
}

.logobar-img-container {
  height: 120px;
}

.logobar-img-container img {
  height: 100%;
  margin-left: 50px;
}

/* --------- End Logo Bar Css ---------- */

/* --------- Start Fantasy Liineup (About) Css ---------- */
.sec-title {
  font-size: 48px;
  margin-bottom: 20px;
}

.about .label {
  color: #669900;
}

.about .about-img-container {
  height: 240px;
}
/* --------- End Fantasy Liineup (About) Css ---------- */

/* --------- Start CTA Css ---------- */
.call-to-action {
  background: #669900;
  color: #ffffff;
  position: relative;
  z-index: 0;
}

.call-to-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: url(/public/img/CTA_Left_circle.png);
  width: 190px;
  height: 190px;
  z-index: 1;
}

.call-to-action::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  background: url(/public/img/CTA_Right_circle.png);
  width: 220px;
  height: 180px;
  z-index: 1;
}

.call-to-action .row {
  width: 70%;
  margin: 0 auto;
}

.call-to-action .cta-title {
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 0;
  line-height: normal;
  position: relative;
  z-index: 2;
}

.call-to-action .about-content {
  text-align: right;
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.call-to-action .cta-title,
.call-to-action .about-content {
  position: relative;
  z-index: 2;
}

/* --------- End CTA Css ---------- */

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

/* --------- Start Fanduel & Draftkings Optimizer Css ---------- */

.fdo-card {
  padding: 40px;
  transition: all 0.3s ease-in-out 0s;
  border-radius: 12px;
  text-align: center;
  min-height: 420px;
  display: flex;
  align-items: center;
}

.fdo-section .fdo-card:hover {
  transform: translateY(-20px);
  box-shadow: 0px 8px 30px 0px rgba(102, 153, 0, 0.15);
}

.fdo-card .box-container {
  height: 100%;
}

.fdo-card .img-container {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 0 auto;
  background: #669900;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 30px;
  transition: all 1s ease-in-out 0s;
}

.fdo-card:hover .img-container {
  transform: rotate(360deg);
}

.fdo-card h4 {
  font-size: 24px;
  text-transform: capitalize;
  margin-bottom: 16px;
}

.fdo-card p {
  margin-bottom: 0;
}

/* --------- End Fanduel & Draftkings Optimizer Css ---------- */

/* --------- Start Design Insight Css ---------- */
.dfs-insight {
  background: #669900;
}

.dfs-insight .section-header h2,
.dfs-insight .section-header p {
  color: #ffffff;
}

.dfs-insight .fdo-card {
  background: #ffffff;
  height: auto;
}

.dfs-insight .fdo-card .img-container {
  transition: all 1s ease-in-out 0s;
  background: rgba(102, 153, 0, 0.1);
}

.dfs-insight .fdo-card .img-container .img-box {
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #669900;
  transition: all 1s ease-in-out 0s;
}

.dfs-insight .fdo-card:hover .img-container {
  background: #669900;
}

.dfs-insight .fdo-card:hover .img-container .img-box {
  border: 4px solid #000000;
}

.dfs-insight .fdo-card .box-container {
  height: auto;
}

.dfs-insight .fdo-card:hover {
  transform: translateY(-20px);
  box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.3);
}

.dfs-insight .btn-box {
  margin-top: 60px;
}

/* --------- End Design Insight Css ---------- */

/* --------- Start DFS Strategy Guides Css ---------- */

.dfs-guide .fdo-card {
  border: 1px solid #669900;
  min-height: 200px;
}

.dfs-guide .fdo-card h4 {
  color: #669900;
  margin-bottom: 0;
  font-weight: 500;
}

.dfs-guide .fdo-card:hover {
  color: #ffffff;
  background: #669900;
}

.dfs-guide .fdo-card:hover h4 {
  color: #ffffff;
}

.dfs-guide .fdo-card:hover {
  transform: translateY(-20px);
  box-shadow: 0px 8px 30px 0px rgba(102, 153, 0, 0.15);
}

/* --------- End DFS Strategy Guides Css ---------- */

/* --------- Start Footer Css ---------- */

.footer {
  background: #000000;
  text-align: center;
}

.footer .logo {
  height: 80px;
}

.footer .navbar-nav {
  width: 100%;
  margin-top: 40px;
  flex-direction: row;
  justify-content: center;
}

.footer .navbar-nav .nav-link {
  padding: 0 20px;
  color: #ffffff;
  opacity: 0.7;
}

.footer p.description {
  width: 60%;
  color: #ffffff;
  opacity: 0.7;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
}
/* --------- End Footer Css ---------- */

/* --------- Start Copyright Css ---------- */
.copyright-section {
  background: #669900;
  font-size: 16px;
  padding: 16px 0;
}

.copyright-section .inner-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright-section .navbar-nav {
  flex-direction: row;
}

.copyright-section .nav-link {
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.copyright-section .nav-item:last-child .nav-link {
  border-right: 0;
}

.copyright-section .nav-link,
.copyright-section p {
  color: #ffffff !important;
  padding: 0 12px;
  position: relative;
  line-height: normal;
}

.copyright-section p {
  margin-bottom: 0;
}

/* --------- End Copyright Css ---------- */

/* --------- Start Importatn links ---------- */

.important-links {
  background-color: #669900;
}

.important-links ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.important-links ul li {
  color: #ffffff;
  transition: all 0.3s ease-in-out 0s;
  position: relative;
  padding-left: 24px;
  margin-bottom: 20px;
}

.important-links ul li:nth-last-child(1) {
  margin-bottom: 0;
}

.important-links ul li:hover {
  padding-left: 32px;
}

.important-links ul li::before {
  content: "✦";
  position: absolute;
  top: 1px;
  left: 0;
}

.important-links ul li a {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}

/* --------- End Importatn links ---------- */

/* --------- Start Main content ---------- */

a.dropdown-item {
  font-size: 15px;
  line-height: 24px;
}

a.dropdown-item:hover {
  color: #ffffff;
  background: #669900;
}

.main-content-section {
  font-size: 16px;
}

.main-content-section a {
  color: #669900;
  font-weight: bold;
}

.main-content-section p {
  line-height: 1.5;
}

.main-content-section .sec-title {
  font-size: 40px;
}

.main-content-section .section:nth-child(even) {
  background: rgb(102, 153, 0, 0.05);
}

.main-content-section h3 {
  font-weight: 500;
}

.main-content-section .about-img-container {
  float: left;
  margin-bottom: 20px;
  margin-right: 40px;
}

.main-content-section .section {
  overflow: auto;
}

.main-content-section .about-img-container.logo-img {
  height: 150px;
}

.main-content-section img {
  height: 100%;
}

.about ul,
.main-content-section ul {
  padding-left: 40px;
  list-style: unset;
  font-size: 17px;
  color: #444444;
}

/* .about ul li, */
.section .about-content .list-group ul li {
  list-style: circle;
  margin-bottom: 20px !important;
  line-height: 40px;
}

/* --------- End Main content ---------- */

/* --------- Start pricing-offer  ---------- */
.pricing-offer {
  background: #ef4b4b;
  padding: 10px 0;
  overflow: hidden;
}

.pricing-offer .cta-title {
  font-size: 24px;
}

.pricing-wrapper .pricing-container {
  display: flex;
  width: 70%;
  justify-content: center;
  margin: 0 auto;
  gap: 30px;
}

.pricing-wrapper .section-header {
  margin-bottom: 50px;
}

.pricing-wrapper .pricing-container .pricing-box {
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease-in-out 0s;
  border: 1px solid #f1f1f1;
  /* background: #f1f1f1; */
}

.pricing-wrapper .pricing-container .pricing-box:hover {
  transform: translateY(-20px);
  box-shadow: 0px 8px 30px 0px rgb(102, 153, 0, 0.15);
}

.pricing-wrapper .pricing-container .pricing-box .inner-box {
  padding: 50px 60px;
}

.pricing-wrapper .price {
  color: #669900;
  margin-bottom: 10px;
}

.pricing-wrapper .old-price {
  font-weight: normal;
  font-size: 32px;
  color: #444444;
  /* opacity: 0.7; */
  /* text-decoration-line: line-through;
  text-decoration-color: red; */
}

.strikethrough {
  position: relative;
}

.strikethrough:before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  right: 0;
  border-top: 3px solid;
  border-color: #ef4b4b;

  -webkit-transform: rotate(-10deg);
  -moz-transform: rotate(-10deg);
  -ms-transform: rotate(-10deg);
  -o-transform: rotate(-10deg);
  transform: rotate(-10deg);
}

.pricing-wrapper p {
  margin-bottom: 0;
}

.pricing-wrapper .read-more-btn {
  line-height: 40px;
  padding: 0 20px;
}

.pricing-wrapper .save {
  font-size: 14px;
  color: #ef4b4b;
  background: #669900;
  padding: 8px;
  text-transform: uppercase;
  font-weight: 600;
}

.pricing-wrapper .save p {
  color: #ffffff;
}

.pricing-wrapper .already-member a {
  font-weight: 600;
  color: #669900;
  /* transition: all 0.3s ease-in-out 0s; */
}

.pricing-wrapper .already-member a:hover {
  text-decoration: underline;
}

/* --------- End pricing-offer  ---------- */

/* --------- End servicing ---------- */
.servicing,
.servicing p {
  color: #ffffff;
}

.servicing .section-header {
  margin-bottom: 50px;
}
/* --------- End servicing ---------- */

/* --------- End features ---------- */
.features .section-header {
  margin-bottom: 50px;
}

.features .fdo-card {
  display: block;
  min-height: unset;
  border: 1px solid #f1f1f1;
  margin-bottom: 30px;
}

.features .fdo-card:hover {
  color: unset;
  background: unset;
  transform: scale(1.1);
}

.features .fdo-card:hover h4 {
  color: #669900;
}

.features .fdo-card h4 {
  font-size: 20px;
  margin-bottom: 10px;
}

.features .fdo-card p {
  font-size: 16px;
}

.smallPrice h6 {
  font-size: 10px;
}
/* --------- End features ---------- */

/* --------- End servicing ---------- */
/* --------- End servicing ---------- */
</style>
